export const localeData = [
	...require('react-intl/locale-data/en'),
	...require('react-intl/locale-data/it')
];
